import ResizeObserverPonyfill from 'resize-observer-polyfill';

export const ResizeObserver = window.ResizeObserver ? window.ResizeObserver : ResizeObserverPonyfill;
